// src/i18n/locales/en/settings.ts (Updated)
export const enSettingsTranslations = {
	settings: {
		// Page titles and general labels
		onePageLayout: 'One Page Layout',
		onePageLayoutOptions: {
			yes: 'Yes',
			no: 'No',
		},
		addToCartOptions: {
			yes: 'Yes',
			no: 'No',
		},
		allowedLanguages: 'Allowed Languages',
		allowedLanguagesHelper: 'At least one language must be selected. English is the default fallback.',
		languageOptions: {
			en: 'English',
			ar: 'Arabic',
		},
		isFeedbackEnabled: 'Enable Item Feedback & Rating',
		isFeedbackEnabledOptions: {
			yes: 'Yes',
			no: 'No',
		},
		isFeedbackPubliclyVisible: 'Show Feedback on Items',
		isFeedbackPubliclyVisibleOptions: {
			yes: 'Visible',
			no: 'Hidden',
		},
		title: 'Restaurant Settings',
		subtitle: 'Customize your restaurant\'s appearance and information',
		saveChanges: 'Save Changes',
		saving: 'Saving...',
		saveSuccess: 'Settings saved successfully!',
		resetToDefaults: 'Reset to Defaults',
		hidePreview: 'Hide Preview',
		showPreview: 'Show Preview',
		menuPreview: 'Menu Preview',
		previewDescription: 'This is how your menu will appear to customers',
		livePreview: 'Live Preview',
		unsavedChanges: 'Unsaved Changes',

		// Tabs
		tabs: {
			theme: 'Theme',
			layout: 'Layout',
			typography: 'Typography',
			brand: 'Brand',
			contact: 'Contact',
			hours: 'Hours',
			services: 'Services',
			features: 'Features',
			ingredients: 'Ingredients',
			currency: 'Currency'
		},

		// Theme settings
		colorPalettes: 'Color Palettes',
		customColors: 'Custom Colors',
		primaryColor: 'Primary Color',
		secondaryColor: 'Secondary Color',
		accentColor: 'Accent Color',
		backgroundColor: 'Background Color',
		cardBackgroundColor: 'Card Background',
		textColor: 'Text Color',
		borderColor: 'Border Color',
		cardColor: 'Card Color',

		// Custom Themes
		customThemes: 'Custom Themes',
		defaultTheme: 'Default Theme',
		addTheme: 'Add Theme',
		editTheme: 'Edit Theme',
		deleteTheme: 'Delete Theme',
		saveTheme: 'Save Theme',
		themeName: 'Theme Name',
		themeNamePlaceholder: 'Enter theme name',
		themePreview: 'Theme Preview',
		themeDeleteConfirm: 'Delete this theme?',
		noCustomThemes: 'Create your first custom theme',

		// Style options
		styleOptions: 'Style Options',
		headerStyle: 'Header Style',
		headerStyles: {
			transparent: 'Transparent',
			solid: 'Solid',
			cover: 'Cover'
		},
		cardStyle: 'Card Style',
		cardStyles: {
			minimal: 'Minimal',
			shadow: 'Shadow',
			bordered: 'Bordered'
		},

		// Layout settings
		menuLayout: 'Menu Layout',
		menuStyle: 'Menu Style',
		menuStyles: {
			grid: 'Grid',
			list: 'List'
		},
		SubcategoryStyle: 'Subcategory Style',
		SubcategoryStyles: {
			tabs: 'Tabs',
			dropdown: 'Dropdown'
		},
		menuSortType: 'Menu Sort Order',
		menuSortTypes: {
			manual: 'Manual (Drag & Drop)',
			alphabetic: 'Alphabetical',
			time: 'By Date Added',
		},
		dragToReorder: 'Drag to reorder',
		searchActiveNoDnd: 'Clear search to enable drag-and-drop reordering',
		savingOrder: 'Saving order...',
		borderRadius: 'Border Radius',

		// Typography settings
		fontFamily: 'Font Family',
		titleFontFamily: 'Title Font Family',
		titleFontSize: 'Title Size',
		itemFontSize: 'Item Name Size',
		boldTitles: 'Bold Titles',

		// Brand settings
		restaurantInfo: 'Restaurant Information',
		restaurantName: 'Restaurant Name (English)',
		restaurantNamePlaceholder: 'Enter your restaurant name in English',
		restaurantNameArabic: 'Restaurant Name (Arabic)',
		restaurantNameArabicPlaceholder: 'أدخل اسم مطعمك بالعربية',
		description: 'Description (English)',
		descriptionPlaceholder: 'Describe your restaurant and cuisine in English',
		descriptionArabic: 'Description (Arabic)',
		descriptionArabicPlaceholder: 'صف مطعمك ونوع الطعام بالعربية',
		cuisine: 'Cuisine Type',
		cuisinePlaceholder: 'e.g., Italian, Chinese, American',
		brandImages: 'Brand Images',
		logo: 'Logo',
		uploadLogo: 'Click to upload logo or drag and drop',
		coverImage: 'Cover Image',
		uploadCoverImage: 'Click to upload cover image or drag and drop',
		logoUploaded: 'Logo uploaded successfully',
		coverImageUploaded: 'Cover image uploaded successfully',
		defaultItemImage: 'Default Item Image',
		defaultItemImageUploaded: 'Default item image uploaded successfully',
		uploadDefaultItemImage: 'Click to upload default item image or drag and drop',
		clickToChange: 'Click to change image',
		supportedFormats: 'PNG, JPG, WebP up to 5MB',
		uploading: 'Uploading...',

		// Location settings
		location: 'Location',
		googleMapsLink: 'Google Maps Link',
		googleMapsLinkPlaceholder: 'https://maps.google.com/...',
		coordinatesPlaceholder: '40.71817374700872, -74.01229668987044',
		or: 'OR',
		coordinates: 'Coordinates',
		latitude: 'Latitude',
		longitude: 'Longitude',
		coordinatesHelper: 'You can find coordinates by right-clicking on Google Maps',
		currentLocation: 'Current Location',
		selectOnMap: 'Select on Map',
		mapPicker: 'Map Location Picker',
		dragMarker: 'Drag the marker to select your location',
		confirmLocation: 'Confirm Location',
		cancel: 'Cancel',
		searchLocation: 'Search for a location...',
		useCurrentLocation: 'Use Current Location',
		locationSelected: 'Location Selected',

		// Contact settings
		contactInfo: 'Contact Information',
		phone: 'Phone Number',
		phonePlaceholder: '+1 (555) 123-4567',
		email: 'Email Address',
		emailPlaceholder: 'restaurant@example.com',
		address: 'Address (English)',
		addressPlaceholder: 'Enter your restaurant address in English',
		addressArabic: 'Address (Arabic)',
		addressArabicPlaceholder: 'أدخل عنوان مطعمك بالعربية',
		addAddress: 'Add Address',
		removeAddress: 'Remove Address',
		socialMedia: 'Social Media',
		facebook: 'Facebook',
		instagram: 'Instagram',
		twitter: 'Twitter',

		// Services settings
		services: {
			title: 'Services',
			subtitle: 'Enable and configure advanced services for your restaurant',
			addFeature: 'Add Service',
			noFeatures: 'No Services Added',
			noFeaturesDescription: 'Add services to enhance your restaurant\'s capabilities',
			allFeaturesAdded: 'All available services have been added to your restaurant',
			enabled: 'enabled',
			deleteFeature: 'Delete Service',
			deleteFeatureConfirmation: 'Are you sure you want to delete this service? This action cannot be undone.',
			manageRestaurantFeatures: 'Manage and configure restaurant services',
			addNewFeature: 'Add New Service',
			createCustomFeature: 'Create Custom Service',
			addFirstFeature: 'Add your first service to get started',
			noFeaturesYet: 'No services configured yet',
			noFeaturesFound: 'No services found',
			tryDifferentSearch: 'Try adjusting your search or filter criteria',
			searchFeatures: 'Search services...',
			featureName: 'Service Name',
			enterFeatureName: 'Enter service name',
			featureDescription: 'Description',
			enterFeatureDescription: 'Enter service description',
			enterDescription: 'Enter description...',
			category: 'Category',
			enterCategory: 'Enter category...',
			icon: 'Icon',
			iconUrl: 'Icon URL',
			enterIconUrl: 'Enter icon URL (e.g. https://example.com/icon.png)',
			iconPreview: 'Icon preview',
			enterIconEmoji: 'Enter icon emoji (e.g. 🍕)',
			iconHelp: 'Use an emoji to represent this service',
			featureImage: 'Service Image',
			clickToUpload: 'Click to upload',
			orDragAndDrop: 'or drag and drop',
			allowItems: 'Allow Items',
			allowItemsHelp: 'Enable if this service can be attached to menu items',
			selectFeatureToAdd: 'Select a service to add',
			filterByCategory: 'Filter by Category',
			allCategories: 'All Categories',
			selectCategory: 'Select Category',
			configuration: 'Configuration',
			featureConfiguration: 'Service Configuration',
			configurationText: 'Configuration Text',
			currentConfiguration: 'Current Configuration',
			attachedItems: 'Attached Items',
			configureFeature: 'Configure Service',
			clickAddFeatureToStart: 'Click "Add Service" to start',
			enterConfiguration: 'Enter configuration...',
			enterConfigText: 'Enter configuration text...',
			noConfiguration: 'No configuration',
			editConfiguration: 'Edit Configuration',
			createFeature: 'Create Service',
			creating: 'Creating...',
			removeFeature: 'Remove Service',
			removeFeatureConfirmation: 'Are you sure you want to remove this service from your branch? This action cannot be undone.',
			enterJsonConfiguration: 'Enter JSON configuration...',
			jsonConfigurationHelp: 'Enter valid JSON configuration for this service',
			itemsAttached: 'items attached',
			manageItems: 'Manage Items',
			invalidJsonFormat: 'Invalid JSON format',
			featureInformation: 'Service Information',
			subfeatures: 'Sub-services',
			subfeature: 'Sub-service',
			subfeatureOptional: 'Sub-services (Optional)',
			addSubfeature: 'Add Sub-service',
			subfeatureName: 'Sub-service name',
			subfeatureImage: 'Sub-service Image',
			noSubfeaturesAdded: 'No sub-services added. Click "Add Sub-service" to create one.',
			textClass: 'Text/Class',
			uploadImage: 'Upload Image',
			chooseImage: 'Choose Image',
			uploading: 'Uploading...',
			editFeature: 'Edit Service',
			updateFeature: 'Update Service',
			cancel: 'Cancel',
			hideSettings: 'Hide Settings',
			showSettings: 'Show Settings',
			errorSavingConfiguration: 'Error saving configuration',
			featureIcon: 'Service Icon',
			noIcon: 'No Icon',
			chooseIcon: 'Choose Icon',
			removeIcon: 'Remove',
			updating: 'Updating...',
			nameRequired: 'Service name is required',
			invalidFileType: 'Invalid file type. Only JPEG, PNG, and WebP are allowed.',
			fileTooLarge: 'File is too large. Maximum size is 5MB.',
			errorUploadingImage: 'Failed to upload image. Please try again.'
		},

		fontSizes: 'Font Sizes',

		// Operating hours
		operatingHours: 'Operating Hours',
		customerArrivalTime: 'Customer Arrival Time',
		customerArrivalTimeDescription: 'Specify how long customers should wait before their reservation time',
		selectArrivalTime: 'Select arrival time duration',
		timeOptions: 'Time Options',
		addTimeOption: 'Add Time Option',
		addFirstTimeOption: 'Add Time Option',
		default: 'Default',
		arrivalTimes: {
			fifteenMin: '15 minutes',
			thirtyMin: '30 minutes',
			fortyFiveMin: '45 minutes',
			oneHour: '1 hour',
			twoHours: '2 hours',
		},
		days: {
			monday: 'Monday',
			tuesday: 'Tuesday',
			wednesday: 'Wednesday',
			thursday: 'Thursday',
			friday: 'Friday',
			saturday: 'Saturday',
			sunday: 'Sunday'
		},
		closed: 'Closed',

		// Preview content
		preview: {
			addToCart: 'Add to order'
		},

		// Error messages
		errors: {
			saveFailed: 'Failed to save settings. Please try again.',
			invalidColor: 'Please enter a valid color value',
			requiredField: 'This field is required',
			invalidUrl: 'Please enter a valid URL'
		}
	}
};